import { ErrorBoundary as Boundary } from 'react-error-boundary';

import FallbackComponent from './fallbackComponent/FallbackComponent';

const ErrorBoundary = ({ children }: any) => {
  return <Boundary FallbackComponent={FallbackComponent}>{children}</Boundary>;
};

export default ErrorBoundary;
